export default {
  LIST_FETCHED: 'CATEGORIES_FETCHED',
  LIST_LOAD: 'CATEGORIES_LOAD',
  ITEM_DETAIL: 'CATEGORIES_DETAIL',
  BUTTON_LOAD: 'CATEGORIES_BUTTON_LOAD',
};
